import { createContext, useContext } from 'react';

export const AutomationContext = createContext({
  controls: null,
  setControls: () => {},
});

export const useAutomationContext = () => useContext(AutomationContext);
